<template>
  <v-container>
    <v-row dense class="py-3">
      <v-col v-for="(action,index) in actionsEisy" :key="index" class="px-4" cols="3" :class="action.hidden">
        <v-card tile @click="menu(action.action)" class="ma-5">
          <v-img v-if="logo" :src="logo"
            class="white--text align-end"
            gradient="to bottom, rgba(2,40,68,.83), rgba(9,65,107,.3)"
            max-height="280px">
            <v-card-text class="align-center text-center">
              <div class="mb-4">
                <v-btn fab :color="action.color" elevation="0" x-large dark>
                  <v-icon x-large>{{action.icon}}</v-icon>
                </v-btn>
              </div>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="headline mb-1 title text-uppercase white--text font-weight-bold">{{action.title}}</v-list-item-title>
                  <v-list-item-subtitle class="white--text">{{action.message}}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-img>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import router from '@/router'
import { Permission } from '@/mixins/permissionMain'
// import MainProcessForm from '@/components/forms/main/MainProcessForm'
// import ImportDataField from '@/components/fields/ImportDataField'
export default {
  mixins: [Permission],
  data: () => ({
    logo: null,
    actionsEisy: [
      {
        id: 'rh.empleados-show',
        icon: 'mdi-account-group',
        color: 'lime darken-3',
        action: 'ViewRHEmpleados',
        title: 'Empleados',
        message: 'RH',
        hidden: 'hiddenItem'
      },
      {
        id: 'rh.empleados-catalogos-categorias-show',
        icon: 'mdi-account-group',
        color: 'lime darken-3',
        action: 'ViewNomConfigCategorias',
        title: 'Categorias',
        message: 'RH',
        hidden: 'hiddenItem'
      },
      {
        id: 'rh.empleados-catalogos-plazas-show',
        icon: 'mdi-account-group',
        color: 'lime darken-3',
        action: 'ViewNomConfigPlazas',
        title: 'Plazas',
        message: 'RH',
        hidden: 'hiddenItem'
      },
      {
        id: 'rh.empleados-catalogos-puestos-show',
        icon: 'mdi-account-group',
        color: 'lime darken-3',
        action: 'ViewNomConfigPuestos',
        title: 'Puestos',
        message: 'RH',
        hidden: 'hiddenItem'
      },
      {
        id: 'rh.empleados-catalogos-niveles-show',
        icon: 'mdi-account-group',
        color: 'lime darken-3',
        action: 'ViewNomConfigNiveles',
        title: 'Niveles',
        message: 'RH',
        hidden: 'hiddenItem'
      },
      {
        id: 'asistencia.aplicaciones-show',
        icon: 'mdi-clipboard-check-multiple-outline',
        color: 'primary darken-3',
        action: 'ViewLogApplication',
        title: 'Aplicaciones',
        message: 'Asistencia',
        hidden: 'hiddenItem'
      },
      {
        id: 'asistencia.sistencias-show',
        icon: 'mdi-clipboard-check-multiple-outline',
        color: 'primary darken-3',
        action: 'ViewNomConfigAsistencia',
        title: 'Asistencias',
        message: 'Asistencia',
        hidden: 'hiddenItem'
      },
      {
        id: 'asistencia.horarios-show',
        icon: 'mdi-clipboard-check-multiple-outline',
        color: 'primary darken-3',
        action: 'ViewHorarioAsistencias',
        title: 'Horarios',
        message: 'Asistencia',
        hidden: 'hiddenItem'
      },
      {
        id: 'asistencia.resumenhoras-show',
        icon: 'mdi-clipboard-check-multiple-outline', // mdi-alarm-check
        color: 'primary darken-3',
        action: 'ViewNomConfigIncidencias',
        title: 'Resumen de horas',
        message: 'Asistencia',
        hidden: 'hiddenItem'
      },
      {
        id: 'nomina.nominas-show',
        icon: 'mdi-account-cash-outline', // mdi-bank
        color: 'green darken-2',
        action: 'ViewNomNominaGeneradas',
        title: 'Nomina',
        message: 'Nomina',
        hidden: 'hiddenItem'
      },
      {
        id: 'nomina.cuentas-show',
        icon: 'mdi-account-cash-outline',
        color: 'green darken-2',
        action: 'ViewNomConfigCuentasEmpleados',
        title: 'Cuentas',
        message: 'Nomina',
        hidden: 'hiddenItem'
      },
      {
        id: 'configuracion.importador-show',
        icon: 'mdi-cog-outline', // mdi-alarm-check
        color: 'orange darken-3',
        action: 'ExaImport',
        title: 'Importador',
        message: 'Configuracion',
        hidden: 'hiddenItem'
      },
      {
        id: 'configuracion.accesos-usuarios-show',
        icon: 'mdi-cog-outline', // mdi-alarm-check
        color: 'orange darken-3',
        action: 'ViewConfigAuthUsers',
        title: 'Usuarios',
        message: 'Configuracion',
        hidden: 'hiddenItem'
      },
      {
        id: 'configuracion.accesos-usuarios-show',
        icon: 'mdi-cog-outline', // mdi-alarm-check
        color: 'orange darken-3',
        action: 'ViewConfigAuthRols',
        title: 'Roles',
        message: 'Configuracion',
        hidden: 'hiddenItem'
      },
      {
        id: 'configuracion.accesos-usuarios-show',
        icon: 'mdi-cog-outline', // mdi-alarm-check
        color: 'orange darken-3',
        action: 'ViewConfigAuthPermiss',
        title: 'Permisos',
        message: 'Configuracion',
        hidden: 'hiddenItem'
      },
      {
        id: 'configuracion.accesos-usuarios-show',
        icon: 'mdi-cog-outline', // mdi-alarm-check
        color: 'orange darken-3',
        action: 'ViewConfigDepartments',
        title: 'Departamentos',
        message: 'Configuracion',
        hidden: 'hiddenItem'
      },
      {
        id: 'configuracion.accesos-usuarios-show',
        icon: 'mdi-cog-outline', // mdi-alarm-check
        color: 'orange darken-3',
        action: 'ViewConfigEjercicios',
        title: 'Ejercicios',
        message: 'Configuracion',
        hidden: 'hiddenItem'
      }
    ],
    form: {
      status_finish: {
        formulario: {
          fields: [
            {
              field: 'radioButton',
              name: 'programar',
              nameid: 'programar',
              items: ['Programado', 'No Programado'],
              rules: [],
              row: true,
              cols: 6
            },
            {
              field: 'checkbox',
              name: 'impresoras',
              nameid: 'impresoras',
              items: ['impresoras 1', 'impresoras 2', 'impresoras 3', 'impresoras 4', 'impresoras 5'],
              rules: [],
              row: true,
              cols: 6
            },
            {
              field: 'searchDataServer',
              name: 'Colaborador',
              nameid: 'empleado_id',
              url: '/rh/empleado/find',
              rules: [],
              cols: 6
            },
            {
              field: 'textDatePicker',
              name: 'Fecha',
              nameid: 'fecha',
              rules: [],
              cols: 6
            },
            {
              field: 'selectDataServer',
              name: 'Rols',
              nameid: 'rol_id',
              url: '/config/auth/roles/show',
              rules: [],
              cols: 6
            },
            {
              field: 'text',
              type: 'text',
              name: 'Solicitante',
              nameid: 'solicitante',
              rules: [],
              cols: 6
            }
          ]
        }
      }
    },
    model: {
      impresoras: []
    },
    field: {
      field: 'fileDrapDrop',
      name: 'Cargar Excel de datos',
      nameid: 'conceptos',
      rules: true,
      cols: 12,
      table: {
        header: {
          options: [
            { title: 'Exportar Layout', icon: 'mdi-file-download', color: 'success', action: 'exportData', code: 'libre', hidden: '' },
            { title: 'Cargar Nuevo Excel', icon: 'mdi-file-excel', color: 'primary', action: 'LoadData', code: 'no-libre' }
          ],
          titles: [
            { text: 'plantel', value: 'plantel', class: 'black--text' },
            { text: 'Cve Empleado', value: 'cve_empleado', class: 'black--text' },
            { text: 'Nombre', value: 'nombre', class: 'black--text' },
            { text: 'Base/Plaza', value: 'base-plaza', class: 'black--text' },
            { text: 'Cve Concepto', value: 'cve_concepto', class: 'black--text' },
            { text: 'Concepto', value: 'concepto', class: 'black--text' },
            { text: 'Importe', value: 'importe', class: 'black--text' }
          ],
          loading: false
        },
        body: {
          data: [],
          actions: []
        },
        footer: {
          paging: true
        }
      }
    }
  }),
  components: {
    // MainProcessForm,
    // ImportDataField
  },
  mounted () {
    this.PermisosMenu(JSON.parse(localStorage.getItem('permisos')), this.actionsEisy)
  },
  beforeMount () {
    this.GETUrlLogoSistema('imagen-home')
  },
  methods: {
    ...mapActions(['GETUrlLogoSistema']),
    object () {},
    cancel () {},
    menu (item) {
      router.push({ name: item })
    },
    ...mapMutations([])
  },
  computed: {
    ...mapGetters(['get_logo'])
  },
  watch: {
    get_logo (logo) {
      this.logo = `${logo.formato}${logo.imagen}`
    }
  }
}
</script>
<style scoped>
.hiddenItem {
  display: none;
}
</style>
